// 批改页面
import { sendLogById, sendLogClick } from './index'

export default {
  initPageLogger(data = {}) {
    sendLogById('smallfox-teacher_71', {
      ...data
    })
  },
  batchAudit(data = {}) {
    sendLogClick('smallfox-teacher_70', {
      ...data
    })
  },
  audit(data = {}) {
    sendLogClick('smallfox-teacher_69', {
      ...data
    })
  },
  useCiCard(data = {}) {
    sendLogClick('smallfox-teacher_67', {
      ...data
    })
  }
}